import { Navigate, Outlet, useLocation } from "react-router";
import { useAuth } from "@/modules/auth";
import { usePageLoader } from "@/contexts/page-loader-context";
import { useEffect } from "react";

export default function AuthGuard() {
	const { isAuthenticated, loading } = useAuth();
	const { showLoader, hideLoader } = usePageLoader();
	const location = useLocation();

	useEffect(() => {
		if (loading) {
			showLoader();
		} else {
			hideLoader();
		}
	}, [loading, showLoader, hideLoader]);

	if (loading) {
		return null;
	}

	if (!isAuthenticated) {
		const redirectTo = location.pathname + location.search;

		return <Navigate to={`/login?redirect=${encodeURIComponent(redirectTo)}`} replace />;
	}

	// 4️⃣ Authenticated + workspace → allow access
	return <Outlet />;
}
